var exports = {
  "z": "discussionLink__g14m9w",
};

module.exports = exports;
